/*
 * Site-wide accessibility enhancements. Loaded after theme.js in layout/theme.liquid.
 *
 * theme.js toggles state with classes only (.is-open on accordions, .current on tabs)
 * from many places. Rather than patch each one, mirror those classes into ARIA
 * attributes so screen readers get role and state (WCAG 4.1.2).
 */
(function () {
  const syncOnClassChange = (elements, sync) => {
    if (!elements.length) return;
    const observer = new MutationObserver((mutations) => mutations.forEach((m) => sync(m.target)));
    elements.forEach((el) => {
      sync(el);
      observer.observe(el, {attributes: true, attributeFilter: ['class']});
    });
  };

  const init = () => {
    // Accordions: <p data-accordion-toggle> followed by [data-accordion-body]
    const accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
    accordionToggles.forEach((toggle, i) => {
      if (toggle.tagName !== 'BUTTON') {
        toggle.setAttribute('role', 'button');
        // theme.js activates on Space keyup; stop the page scrolling on keydown like a real button
        toggle.addEventListener('keydown', (event) => {
          if (event.key === ' ') event.preventDefault();
        });
      }
      const body = toggle.parentElement && toggle.parentElement.querySelector('[data-accordion-body]');
      if (body) {
        if (!body.id) body.id = `accordion-body-${i}`;
        toggle.setAttribute('aria-controls', body.id);
      }
    });
    syncOnClassChange(accordionToggles, (toggle) => {
      toggle.setAttribute('aria-expanded', toggle.classList.contains('is-open') ? 'true' : 'false');
    });

    // Tabs: <ul class="tabs"><li class="tab-link tab-link-N" data-tab="N"> + .tab-content-N panels
    const tabLinks = document.querySelectorAll('ul.tabs > li.tab-link');
    tabLinks.forEach((tab) => {
      tab.setAttribute('role', 'tab');
      tab.parentElement.setAttribute('role', 'tablist');
      const container = tab.closest('[data-section-type], .shopify-section') || document;
      const panel = container.querySelector(`.tab-content-${tab.getAttribute('data-tab')}`);
      if (panel) panel.setAttribute('role', 'tabpanel');
    });
    syncOnClassChange(tabLinks, (tab) => {
      tab.setAttribute('aria-selected', tab.classList.contains('current') ? 'true' : 'false');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
